import React from 'react';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.8,
      ease: 'easeInOut',
      delay: 2.5, // Retrasa la salida del contenedor hasta que el texto haya terminado (2.5s)
    },
  },
};

const textContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
  exit: {
    scale: [1, 8, 8],      // 1. Inicia en escala 1, 2. Crecer hasta 8, 3. Mantenerse en 8
    opacity: [1, 1, 0],      // 1. Visible, 2. Sigue visible mientras crece, 3. Desaparecer
    transition: {
      duration: 2.5,
      ease: "easeInOut",
      times: [0, 0.8, 1], // El 80% del tiempo es para el zoom, el 20% para desaparecer
    },
  },
};

const letterVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
  // Se elimina el exit de las letras para que el contenedor principal controle toda la animación de salida
};

const LoadingScreen = () => {
  const text = "SUMAQ MAYU";
  const textLength = text.length;

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="fixed inset-0 bg-gray-950 z-[100000] overflow-hidden"
    >
      {/* Contenedor de la Imagen de Fondo */}
      <motion.div
        className="absolute inset-0 w-full h-full"
        initial={{ scale: 1.15, opacity: 0.8 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 2.5, ease: 'easeOut' }}
      >
        <div
          style={{ backgroundImage: `url(/images/hotel.jpeg)` }}
          className="w-full h-full bg-cover bg-center filter blur-sm"
        />
      </motion.div>
      
      {/* Capa Oscura */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Contenedor de Texto */}
      <div className="relative z-10 flex items-center justify-center h-full">
        <motion.h1
          className="text-white text-3xl sm:text-4xl md:text-5xl font-playfair font-bold tracking-widest drop-shadow-md"
          aria-label={text}
          variants={textContainerVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          style={{ transformOrigin: '45% center' }} // Centra el zoom en la 'M'
        >
          {text.split("").map((char, index) => (
            <motion.span
              key={index}
              variants={letterVariants}
              custom={[index, textLength]}
              style={{ display: 'inline-block', position: 'relative' }}
            >
              {char === 'O' ? (
                <motion.span
                  animate={{
                    scale: [1, 1.05, 1],
                    opacity: [1, 0.8, 1],
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                >
                  {char}
                </motion.span>
              ) : (
                char
              )}
            </motion.span>
          ))}
        </motion.h1>
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
